import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({
      id: 'settings.users.view.disableUserConfirmationModal.header.title',
    }),

    subtitle: translate({
      id: 'settings.users.view.disableUserConfirmationModal.header.subtitle',
    }),
  }))

  return api
}
